var _defs, _circle, _rect, _circle2, _text, _path, _rect2, _circle3, _text2, _rect3, _circle4, _text3, _path2, _rect4, _circle5, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutAndusFinalCtaEngagementPathsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 420,
    viewBox: "0 0 360 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Two ways to engage with AndUs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "aboutCtaGlow"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 218,
    r: 174,
    fill: "url(#aboutCtaGlow)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 28,
    width: 276,
    height: 94,
    rx: 20,
    fill: "#07152A",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 75,
    r: 7,
    fill: "#30D6A1"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 68,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 88,
    dy: 0
  }, "YOUR OPERATIONAL PROBLEM"), /*#__PURE__*/React.createElement("tspan", {
    x: 88,
    dy: 20
  }, "The shared starting point"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 122v38M180 160H95v25M180 160h85v25",
    fill: "none",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 186,
    width: 154,
    height: 118,
    rx: 18,
    fill: "#FFFFFF",
    fillOpacity: 0.94,
    stroke: "#087CFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 216,
    r: 7,
    fill: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 212,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 820,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60,
    dy: 0
  }, "READY PLATFORM"), /*#__PURE__*/React.createElement("tspan", {
    x: 60,
    dy: 18
  }, "Unity \xB7 TalentLenz"), /*#__PURE__*/React.createElement("tspan", {
    x: 60,
    dy: 18
  }, "FleetCore"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 186,
    width: 154,
    height: 118,
    rx: 18,
    fill: "#FFFFFF",
    fillOpacity: 0.94,
    stroke: "#FF2775"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 216,
    r: 7,
    fill: "#FF2775"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 212,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 820,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 230,
    dy: 0
  }, "CUSTOM SYSTEM"), /*#__PURE__*/React.createElement("tspan", {
    x: 230,
    dy: 18
  }, "Designed around"), /*#__PURE__*/React.createElement("tspan", {
    x: 230,
    dy: 18
  }, "your operation"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 304v34h170v-34M180 338v20",
    fill: "none",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 359,
    width: 240,
    height: 42,
    rx: 13,
    fill: "#10243E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 380,
    r: 6,
    fill: "#30D6A1"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 101,
    y: 385,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "A PRACTICAL NEXT STEP")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutAndusFinalCtaEngagementPathsMobile);
export default __webpack_public_path__ + "static/media/about-andus-final-cta-engagement-paths-mobile.bd0be25c4554f352a567372dd3fea659.svg";
export { ForwardRef as ReactComponent };